var EColumnType = /* @__PURE__ */ ((EColumnType2) => {
  EColumnType2["string"] = "string";
  EColumnType2["number"] = "number";
  EColumnType2["boolean"] = "boolean";
  EColumnType2["enum"] = "enum";
  EColumnType2["date"] = "date";
  EColumnType2["stringList"] = "string-list";
  EColumnType2["enumList"] = "enum-list";
  return EColumnType2;
})(EColumnType || {});
export {
  EColumnType
};
